import { ref, computed } from '@vue/composition-api'

export default function usePermissions() {


  const refListTable = ref(null)

  const perPage = ref(30)
  const totalTable = ref(0)
  const currentPage = ref(1)
  const perPageOptions = [5, 10, 25, 50, 100, 500, 1000, 2000]
  const searchQuery = ref('')


  const dataMeta = computed(() => {

    const localItemsCount = refListTable.value ? refListTable.value.localItems.length : 0
    return {
      from: perPage.value * (currentPage.value - 1) + (localItemsCount ? 1 : 0),
      to: perPage.value * (currentPage.value - 1) + localItemsCount,
      of: totalTable.value,
    }
  })

  return {
    perPage,
    totalTable,
    currentPage,
    perPageOptions,
    searchQuery,
    dataMeta
  }

}
